import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import GlobalStyles from './styles/GlobalStyles';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import SaveTheDate from './pages/SaveTheDate';
import RSVP from './pages/RSVP';
import WeddingDetails from './pages/WeddingDetails';
import Registry from './pages/Registry';
import OurStory from './pages/OurStory';
import Photos from './pages/Photos';
import PasswordProtection from './components/PasswordProtection';
import LiveOdds from './pages/LiveOdds';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Layout from './components/Layout';




function App() {
  return (
    // Wrap with HelmetProvider since you're importing it
    <HelmetProvider>
      <Router>
        <AuthProvider>
          <GlobalStyles />
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            
            
            {/* Protected Routes with Layout */}
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              <Route index element={<Home />} />
              <Route path="our-story" element={<OurStory />} />
              <Route path="wedding-details" element={<WeddingDetails />} />
              <Route path="registry" element={<Registry />} />
              <Route path="rsvp" element={<RSVP />} />
              <Route path="liveodds" element={<LiveOdds />} />
              <Route path="/save-the-date" element={<SaveTheDate />} />
            </Route>
            
            {/* Redirect any unknown routes to login */}
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;